module.exports = __webpack_public_path__ + "static/media/firstlithoniageriatrichealth.d6a74212.jpeg";